<template>
  <v-skeleton-loader :loading="loading" :types="skeleton" type="article, actions">
    <v-card class="elevation-1 mb-6 rounded-lg mt-0">
      <v-card-title class="pa-7">
        Hodnoty | Elektrikář
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text class="pa-7">
        <v-row>
          <v-col cols="12">
            <v-row class="pb-6">
              <v-col cols="4" class="py-0">
                <div class="request-label">PSČ</div>
                <div class="request-value mt-2">
                  {{ value.postalCode }}
                </div>
              </v-col>
              <v-col cols="4" class="py-0">
                <div class="request-label">Termín</div>
                <div class="request-value mt-2">
                  {{ value.term ? $dayjs(value.term).format('D.M.YYYY') : '-' }}
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-row class="pb-6">
              <v-col cols="4" class="py-0">
                <div class="request-label">Objekt</div>
                <div class="request-value mt-2">
                  {{ value.area.name }}
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-divider class="mr-3 ml-3"></v-divider>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-row class="pb-6">
              <v-col class="py-0">
                <template v-if="value.types.length > 0">
                  <div v-if="newOm" class="mt-6">
                    <div class="request-label">Typ práce</div>
                    <div v-for="item in value.types" :key="item.id" class="request-value mt-2">
                      {{ item.name }}
                    </div>
                  </div>
                  <div v-if="!newOm && smallTypes.length > 0" class="mt-6">
                    <div class="request-label">Drobné elektrikářské práce</div>
                    <div v-for="item in smallTypes" :key="item.id" class="request-value mt-2">
                      {{ item.name }}
                    </div>
                  </div>
                  <div v-if="!newOm && largeTypes.length > 0" class="mt-6">
                    <div class="request-label">Větší elektrikářské práce</div>
                    <div v-for="item in largeTypes" :key="item.id" class="request-value mt-2">
                      {{ item.name }}
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="request-label mt-6">Typ práce</div>
                  <div class="request-value mt-2">
                    {{ '-' }}
                  </div>
                </template>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-row class="pb-6">
              <v-col cols="12" class="py-0">
                <div class="request-label">Požadavek</div>
                <div class="request-value mt-2">
                  {{ value.content ? value.content : '-' }}
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-divider class="mb-6 mr-3 ml-3"></v-divider>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-row class="pb-6">
              <v-col cols="4" class="py-0">
                <div class="request-label">EAN</div>
                <div class="request-value mt-2">
                  {{ value.ean ? value.ean : '-' }}
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pl-7 pr-7 pb-7">
        <v-spacer></v-spacer>
        <template>
          <v-btn
            type="submit"
            height="40px"
            min-width="130px"
            color="primary"
            depressed
            :to="{ name: 'orders.edit', params: { id: this.$route.params.id } }"
          >
            Editovat
          </v-btn>
        </template>
      </v-card-actions>
    </v-card>
    <AddressDetail
      v-if="value.address"
      :id="value.address.id"
      v-model="value.address"
      :order-id="id"
      :order="true"
      title="Adresa realizace"
    />
  </v-skeleton-loader>
</template>

<script>
import AddressDetail from '../address/AddressDetail'
export default {
  name: 'OrderElectricityWorkDetail',
  components: { AddressDetail },
  props: {
    value: {
      type: Object,
      required: true,
    },
    id: {
      type: [String, Number],
      required: true,
    },
    newOm: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      skeleton: {
        article: 'heading, paragraph@2',
      },
      order: {},
      loading: false,
      saving: false,
    }
  },
  computed: {
    smallTypes() {
      return this.value.types.filter((e) => e.kind === 'SMALL')
    },
    largeTypes() {
      return this.value.types.filter((e) => e.kind === 'LARGE')
    },
  },
}
</script>
